import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import useUserName from 'flow-doctor-lib/hooks/useUserName';
import { getUserUrl } from 'flow-doctor-lib/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
const UserNameLink = ({
  portalId,
  userId
}) => {
  const {
    loading,
    error,
    data: fullUserName
  } = useUserName({
    userId
  });
  const userUrl = getUserUrl({
    userId,
    portalId
  });
  if (error) {
    return /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.references.user.unknownUser"
      })
    });
  }
  if (loading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return /*#__PURE__*/_jsx(UILink, {
    external: true,
    href: userUrl,
    children: fullUserName
  });
};
export default UserNameLink;